"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _PromoCodeDialog = _interopRequireDefault(require("./PromoCodeDialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TARGET_FLOW_LABELS = {
  LemonCoinPurchase: 'Aquisição de Lemon Coins',
  FreemiumFeature: 'Funcionalidade Freemium'
};
var formatDate = function formatDate(isoString) {
  if (!isoString) return '';
  try {
    return new Date(isoString).toLocaleDateString('pt-BR');
  } catch (_unused) {
    return isoString;
  }
};
var PromoCodesPanel = function PromoCodesPanel(_ref) {
  var httpClient = _ref.httpClient;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    codes = _useState2[0],
    setCodes = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    success = _useState8[0],
    setSuccess = _useState8[1];
  var _useState9 = (0, _react.useState)({
      open: false,
      code: null
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    dialog = _useState0[0],
    setDialog = _useState0[1];
  var load = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var response, _err$response, _err$response2, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          setIsLoading(true);
          setError(null);
          _context.p = 1;
          _context.n = 2;
          return httpClient.get('/backoffice/promotional-codes');
        case 2:
          response = _context.v;
          setCodes(response.data);
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          setError(((_err$response = _t.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.Message) || ((_err$response2 = _t.response) === null || _err$response2 === void 0 || (_err$response2 = _err$response2.data) === null || _err$response2 === void 0 ? void 0 : _err$response2.message) || _t.message || 'Ocorreu um erro inesperado.');
        case 4:
          _context.p = 4;
          setIsLoading(false);
          return _context.f(4);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3, 4, 5]]);
  })), [httpClient]);
  (0, _react.useEffect)(function () {
    load();
  }, [load]);
  var handleSaved = function handleSaved() {
    setDialog({
      open: false,
      code: null
    });
    setSuccess('Código promocional salvo.');
    load();
  };
  var handleToggleActive = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(code) {
      var _err$response3, _err$response4, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setError(null);
            _context2.p = 1;
            _context2.n = 2;
            return httpClient.put("/backoffice/promotional-codes/".concat(code.id, "/active"), !code.isActive, {
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 2:
            setSuccess(code.isActive ? 'Código desativado.' : 'Código reativado.');
            load();
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            setError(((_err$response3 = _t2.response) === null || _err$response3 === void 0 || (_err$response3 = _err$response3.data) === null || _err$response3 === void 0 ? void 0 : _err$response3.Message) || ((_err$response4 = _t2.response) === null || _err$response4 === void 0 || (_err$response4 = _err$response4.data) === null || _err$response4 === void 0 ? void 0 : _err$response4.message) || _t2.message || 'Ocorreu um erro inesperado.');
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function handleToggleActive(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "subtitle1",
    sx: {
      color: '#f77513',
      fontWeight: 'bold'
    }
  }, "C\xF3digos Promocionais"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
    variant: "contained",
    style: {
      backgroundColor: '#f77513',
      color: 'white'
    },
    onClick: function onClick() {
      return setDialog({
        open: true,
        code: null
      });
    }
  }, "+ Novo c\xF3digo")), error && /*#__PURE__*/_react["default"].createElement(_material.Alert, {
    severity: "error",
    sx: {
      mb: 2
    }
  }, error), success && /*#__PURE__*/_react["default"].createElement(_material.Alert, {
    severity: "success",
    sx: {
      mb: 2
    },
    onClose: function onClose() {
      return setSuccess(null);
    }
  }, success), isLoading ? /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      textAlign: 'center',
      py: 4
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: 28,
    style: {
      color: '#f77513'
    }
  })) : /*#__PURE__*/_react["default"].createElement(_material.TableContainer, {
    component: _material.Paper,
    variant: "outlined",
    sx: {
      borderRadius: '14px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Table, {
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
    style: {
      backgroundColor: '#fff4ec'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, "C\xF3digo"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, "Aplic\xE1vel a"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
    align: "right"
  }, "Desconto"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, "Validade"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
    align: "right"
  }, "Resgates"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
    align: "right"
  }, "A\xE7\xF5es"))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, codes.length === 0 && /*#__PURE__*/_react["default"].createElement(_material.TableRow, null, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
    colSpan: 6,
    align: "center",
    style: {
      color: '#aaa',
      padding: '24px'
    }
  }, "Nenhum c\xF3digo promocional cadastrado ainda")), codes.map(function (code) {
    return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
      key: code.id
    }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      sx: {
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: 0.5
      }
    }, code.code, !code.isActive && /*#__PURE__*/_react["default"].createElement(_material.Chip, {
      label: "Desativado",
      size: "small"
    })), code.description && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "caption",
      color: "text.secondary"
    }, code.description)), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, TARGET_FLOW_LABELS[code.targetFlow] || code.targetFlow), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      align: "right"
    }, code.discountPercentage, "%"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, formatDate(code.validFrom), " \u2014 ", formatDate(code.validTo)), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      align: "right"
    }, code.redemptionCount, " / ", code.maxRedemptions), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      align: "right"
    }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
      size: "small",
      onClick: function onClick() {
        return setDialog({
          open: true,
          code: code
        });
      },
      style: {
        color: '#f77513'
      }
    }, "Editar"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
      size: "small",
      onClick: function onClick() {
        return handleToggleActive(code);
      },
      color: code.isActive ? 'error' : 'success'
    }, code.isActive ? 'Desativar' : 'Ativar')));
  })))), /*#__PURE__*/_react["default"].createElement(_PromoCodeDialog["default"], {
    open: dialog.open,
    onClose: function onClose() {
      return setDialog({
        open: false,
        code: null
      });
    },
    httpClient: httpClient,
    initialCode: dialog.code,
    onSaved: handleSaved
  }));
};
var _default = exports["default"] = PromoCodesPanel;